import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HomePage } from './pages/HomePage';
import { AboutPage } from './pages/AboutPage';
import { MinistriesPage } from './pages/MinistriesPage';
import { MinistryDetailPage } from './pages/MinistryDetailPage';
import { ContactPage } from './pages/ContactPage';
import { GivePage } from './pages/GivePage';
import { LiveStreamPage } from './pages/LiveStreamPage';
import { BlogPage } from './pages/BlogPage';
import { BlogDetailPage } from './pages/BlogDetailPage';
import { WhatWeBelievePage } from './pages/WhatWeBelievePage';
import { PlanYourVisitPage } from './pages/PlanYourVisitPage';
import { ResourcesPage } from './pages/ResourcesPage';
import { EventsPage } from './pages/EventsPage';
import { JoinTeamPage } from './pages/JoinTeamPage';
import { ScrollToTop } from './components/layout/ScrollToTop';
export function App() {
  return <Router data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <Routes data-id="element-2">
        <Route path="/" element={<HomePage data-id="element-4" />} data-id="element-3" />
        <Route path="/about" element={<AboutPage data-id="element-6" />} data-id="element-5" />
        <Route path="/visit" element={<PlanYourVisitPage data-id="element-8" />} data-id="element-7" />
        <Route path="/blog" element={<BlogPage data-id="element-10" />} data-id="element-9" />
        <Route path="/blog/:id" element={<BlogDetailPage data-id="element-12" />} data-id="element-11" />
        <Route path="/ministries" element={<MinistriesPage data-id="element-14" />} data-id="element-13" />
        <Route path="/ministry/:id" element={<MinistryDetailPage data-id="element-16" />} data-id="element-15" />
        <Route path="/what-we-believe" element={<WhatWeBelievePage data-id="element-18" />} data-id="element-17" />
        <Route path="/live" element={<LiveStreamPage data-id="element-20" />} data-id="element-19" />
        <Route path="/resources" element={<ResourcesPage data-id="element-22" />} data-id="element-21" />
        <Route path="/contact" element={<ContactPage data-id="element-24" />} data-id="element-23" />
        <Route path="/give" element={<GivePage data-id="element-26" />} data-id="element-25" />
        <Route path="/events" element={<EventsPage data-id="element-28" />} data-id="element-27" />
        <Route path="/join-team" element={<JoinTeamPage data-id="element-30" />} data-id="element-29" />
      </Routes>
    </Router>;
}